module.exports = __webpack_public_path__ + "static/media/ui1.aa82ec6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/work/ui1.png
// module id = 57
// module chunks = 0